import React from 'react';
import { Button } from 'wbm-inputs';
import ChevronRightOutlinedIcon from '@material-ui/icons/ChevronRightOutlined';

type BreadProps = {
    links: any
}
  
export const MultiBreadcrumbs = ({ ...props }: BreadProps) => {
    return (
        <React.Fragment>
            {props.links.map((bread, index) => {
                if(index+1 === props.links.length) {
                    return (
                        <div key={"bread"+index} className="bread-item">
                            {bread.text}
                        </div>
                    )
                } else {
                    return (
                        <div key={"bread"+index} className="bread-item">
                            <Button className="btn-link medium">
                                <a className="bread-link" href={bread.url}>
                                    {bread.text}
                                </a>
                            </Button>
                            <ChevronRightOutlinedIcon className="bread-chev"/>
                        </div>
                    )
                }
                
            })}
        </React.Fragment>
    );
}
